import { render, staticRenderFns } from "./KPIsCatalog.vue?vue&type=template&id=3656a45a&scoped=true"
import script from "./KPIsCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIsCatalog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIsCatalog.vue?vue&type=style&index=0&id=3656a45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656a45a",
  null
  
)

export default component.exports